/**
 * This file contains all model used by the shift RPC endpoint
 *
 * Note: properties starting with a '_' are removed before sending
 *
 * @module app.model
 * @license Copyright 2013 (c) RISE Ges.m.b.H.
 *  ____   ___  ____   _____
 * |  _ \  | | / ___| | ____|
 * | |_) | | | \___ \ |  _|
 * |  _ <  | |  ___) || |___
 * |_| \_\ |_| |____/ |_____|
 *
 */
(function(app) {
    "use strict";

    // Models _need_ to be a function with a name (NOT an anonymous function!)
    app.model.EventField = function EventField(json) {
        var obj = (typeof json === 'string') ? JSON.parse(json) : json;

        if (!obj) {
            obj = {};
        }

        this.id                  = obj.id != null ? parseInt(obj.id) : null;
        this.event_id            = obj.event_id != null ? parseInt(obj.event_id) : null;
        this.event_field_type_id = obj.event_field_type_id ? parseInt(obj.event_field_type_id) : null;
        this.content             = obj.content ? obj.content : null;
    };

}(window.app));
